import { useTranslation } from 'react-i18next';
import { ChatMessageErrorLabelProps } from './types';

export const ChatMessageErrorLabel = ({ messageKey }: ChatMessageErrorLabelProps) => {
    const { t } = useTranslation();
    return (
        <div
            data-testid="chat-message-error"
            role="alert"
            className="absolute -bottom-2 inset-x-6 bg-warning-light border-2 border-warning rounded-t-lg text-warning text-center text-sm pt-1 pb-3 px-2"
        >
            {t(messageKey)}
        </div>
    );
};
